import { useCallback, useSyncExternalStore } from "react";
import site from "./site";

export type ThemeMode = "light" | "dark";

// Выбор пользователя важнее темы из site.json: сохраняем в localStorage и переиспользуем на всех экранах.
const KEY = "flash_theme_mode";
const FALLBACK: ThemeMode = (site as { theme?: { mode?: string } }).theme?.mode === "dark" ? "dark" : "light";

const read = (): ThemeMode => {
  try {
    const saved = window.localStorage.getItem(KEY);
    if (saved === "dark" || saved === "light") return saved;
  } catch {
    // приватный режим / отключённое хранилище — тихо остаёмся на теме по умолчанию
  }
  return FALLBACK;
};

let current: ThemeMode | null = null;
const listeners = new Set<() => void>();

const getSnapshot = (): ThemeMode => {
  if (current === null) current = read();
  return current;
};

const getServerSnapshot = (): ThemeMode => FALLBACK;

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export function setThemeMode(mode: ThemeMode) {
  current = mode;
  try {
    window.localStorage.setItem(KEY, mode);
  } catch {
    // не смогли сохранить — тема всё равно применится до перезагрузки
  }
  listeners.forEach((listener) => listener());
}

export function useThemeMode() {
  const mode = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  const set = useCallback((next: ThemeMode) => setThemeMode(next), []);
  const toggle = useCallback(() => setThemeMode(getSnapshot() === "dark" ? "light" : "dark"), []);
  return { mode, set, toggle };
}